import { AlertTriangle, CircleHelp, Eye, Sparkles } from 'lucide-react';
import { buttonClass, money, shellCard } from './shared.jsx';

function SummaryLine({ label, value }) {
  return (
    <div className="rounded-xl border border-[rgba(var(--border),0.28)] bg-[rgba(var(--panel),0.42)] px-3 py-2">
      <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[rgba(var(--muted),0.95)]">{label}</p>
      <p className="mt-1 text-sm text-[rgb(var(--fg))]">{value}</p>
    </div>
  );
}

export default function RuleSummaryPanel({
  status,
  activeVersionLabel,
  activeConceptLabel,
  previewText,
  warnings,
  form,
  onOpenHelp,
}) {
  return (
    <aside className={`${shellCard} sticky top-24 space-y-3 p-4`}>
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[rgba(var(--muted),0.95)]">Resumen vivo</p>
          <h3 className="mt-1 text-base font-semibold text-[rgb(var(--fg))]">Interpretación operativa</h3>
        </div>
        <button type="button" className={buttonClass} onClick={onOpenHelp} aria-label="Abrir ayuda contextual">
          <CircleHelp className="h-4 w-4" />
        </button>
      </div>

      <div className="rounded-2xl border border-[rgba(var(--brand),0.24)] bg-[rgba(var(--brand),0.08)] p-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-[rgb(var(--fg))]">
          <Eye className="h-4 w-4 text-[rgb(var(--brand))]" aria-hidden="true" />
          Estado actual
        </div>
        <p className="mt-2 text-sm text-[rgba(var(--fg),0.86)]">{status}</p>
        <p className="mt-2 text-sm leading-6 text-[rgba(var(--fg),0.86)]">{previewText || 'Completá contexto, alcance y cálculo para ver una lectura de negocio compacta.'}</p>
      </div>

      <div className="grid gap-2">
        <SummaryLine label="Lista / versión" value={activeVersionLabel || 'Sin seleccionar'} />
        <SummaryLine label="Concepto" value={activeConceptLabel || 'Sin seleccionar'} />
        <SummaryLine label="Prioridad" value={String(form.prioridad || 0)} />
        <SummaryLine label="Método" value={form.metodoCalculo || 'Sin método'} />
        <SummaryLine label="Importe" value={form.metodoCalculo === 'PORCENTAJE' ? `${Number(form.porcentaje || 0)}%` : money(form.valorUnitario || 0)} />
      </div>

      <div className="rounded-2xl border border-[rgba(var(--border),0.3)] bg-[rgba(var(--subpanel),0.14)] p-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-[rgb(var(--fg))]">
          <Sparkles className="h-4 w-4 text-[rgb(var(--brand))]" aria-hidden="true" />
          Ayuda breve
        </div>
        <ul className="mt-2 space-y-2 text-sm text-[rgba(var(--fg),0.82)]">
          <li>Más especificidad gana antes que la prioridad.</li>
          <li>Usá fijo para cargo por guía, por unidad para base física y porcentaje para base monetaria.</li>
          <li>Si cargás excepciones, dejá observaciones para soporte y auditoría.</li>
        </ul>
      </div>

      <div className="rounded-2xl border border-[rgba(var(--border),0.3)] bg-[rgba(var(--subpanel),0.14)] p-3">
        <div className="flex items-center gap-2 text-sm font-semibold text-[rgb(var(--fg))]">
          <AlertTriangle className="h-4 w-4 text-[rgb(var(--brand))]" aria-hidden="true" />
          Alertas
        </div>
        {warnings.length ? (
          <ul className="mt-2 space-y-2 text-sm text-[rgba(var(--fg),0.82)]">
            {warnings.map((warning) => <li key={warning}>{warning}</li>)}
          </ul>
        ) : (
          <p className="mt-2 text-sm text-[rgba(var(--muted),0.95)]">No hay advertencias relevantes por ahora.</p>
        )}
      </div>
    </aside>
  );
}
